import FilmwebLink from "src/components/filmweblink/FilmwebLink";
import styled from "src/lib/styles/css";

const SProviderLink = styled(FilmwebLink)`
	background-color: var(--palette-lilla-mørk-hovedfarge);
	border: 2px solid var(--textcolor);
	border-radius: 4px;
	width: 160px;
	height: 65px;
	display: flex;
	justify-content: center;
	align-items: center;
	color: var(--textcolor);
`;

export default SProviderLink;